import Vue from 'vue'
import api from '@/config/api'
import auth from '@/config/auth'
import { Auth, API, graphqlOperation } from 'aws-amplify'
import { getUser, listUserPermissions } from '@/graphql/queries'

const getUrl = (url) => {
  let urlArray = []
  if (auth.api) {
    urlArray.push(auth.api)
  } else {
    urlArray.push(api.url)
    if (api.path.prefix) {
      urlArray.push(api.path.prefix)
    }
  }
  if (auth.prefix) {
    urlArray.push(auth.prefix)
  }
  urlArray.push(url)
  return urlArray.join('/')
}

const actions = {
  login ({ commit }, data) {
    console.log(data)
    var userdata = {
      token: data.getIdToken().getJwtToken(),
      user: {
        id: data.getIdToken().payload['custom:omsagtools-user-id'],
        name: data.getAccessToken().payload.username,
        email: data.getIdToken().payload.email,
      },
      permissions: data.getIdToken().payload['cognito:groups'], // cognito:groups are set in lambda pre token generarion function(!)
    }
    commit('login', userdata)

    // API.graphql(graphqlOperation(getUser, { id: userdata.user.id }))
    //   .then(response => {
    //     console.log(response)
    //   })
    //   .catch(error => console.log(error))

    // commit('loginWait', true)
    // return Auth.signIn({
    //   username,
    //   password, // Optional, the password
    // })
    //   .then(function (user) {
    //     commit('login', user)
    //     console.log(user)
    //   })
    //   .catch(function (err) {
    //     console.log(err)
    //     commit('loginWait', false)
    //     commit('loginFailed')
    //   })
    // return new Promise((resolve) => {
    //   const path = auth.paths.login || 'login'
    //   Vue.http.post(getUrl(path), credential)
    //     .then(response => response.json())
    //     .then((result) => {
    //       commit('login', result)
    //       resolve()
    //     })
    //     .catch(() => {
    //       commit('loginWait', false)
    //       commit('loginFailed')
    //     })
    // })
  },
  logout ({ commit }) {
    // return new Promise((resolve) => {
    return Auth.signOut({ global: true })
    // .then(response => response.json())
      .then(data => {
        console.log(data)
        // this.setModule('home.name')
        // this.setPage(null)
      })
      .then(() => {
        commit('logout')
        // resolve()
      })
      .catch(err => console.log(err))
    // })

    // return Auth.signOut()
    //   .then(function (data) {
    //     console.log('logout')
    //     commit('logout')
    //   })
    //   .catch(function (err) {
    //     console.log(err)
    //   })

    // return new Promise((resolve) => {
    //   const path = auth.paths.logout || 'logout'
    //   Vue.http.post(getUrl(path))
    //     .then(response => response.json())
    //     .then(() => {
    //       commit('logout')
    //       resolve()
    //     })
    // })
  },
  getUser ({ commit }) {
    return new Promise((resolve) => {
      const path = auth.paths.getUser || 'user'
      Vue.http.get(getUrl(path))
        .then(response => response.json())
        .then((response) => {
          if ([
            400,
            401,
            403,
          ].includes(response.status)) {
            commit('logout')
          }
          resolve()
        })
    })
  },
  refreshToken ({
    commit,
  }, data) {
    Auth.currentSession()
      .then(function (data) {
        let result = {
          token: data.getIdToken().getJwtToken(),
        }
        commit('refreshToken', result)
      })
    // const path = auth.paths.refreshToken || 'refresh-token'
    // Vue.http.post(getUrl(path))
    //   .then(response => response.json())
    //   .then((result) => {
    //     commit('refreshToken', result)
    //   })
  },
  editUser ({ commit, dispatch }, data) {
    const path = auth.paths.editUser || 'user'
    Vue.http.post(getUrl(path), data)
      .then(response => {
        let result = response.body
        commit('editUser', result)
      }, (error) => {
        dispatch('openAlertBox', [
          'alertError',
          error.statusText,
        ], { root: true })
      })
  },
  editPassword ({
    commit,
    dispatch,
  }, data) {
    const path = auth.paths.changePassword || 'password'
    Vue.http.post(getUrl(path), data)
      .then(response => {
        let result = response.body
        commit('editPassword', result)
      }, (error) => {
        dispatch('openAlertBox', [
          'alertError',
          error.statusText,
        ], { root: true })
      })
  },
}

export default actions
